import styled from 'styled-components';

export const FlashScreenStyled = styled.div`
    display: flex;
    padding: 0 16px;
    height: 100%;
    align-items: center;
    justify-content: center;
    background: var(--color-overlay-primary);
    backdrop-filter: blur(3px);
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
`;

export const FlashScreenContentStyled = styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;
    width: 100%;
    position: relative;
    max-width: 350px;
    
    h2 {
        font-weight: 400;
        margin-top: 16px;
    }
    
    p {
        margin-top: 16px;
        margin-bottom: 0;
    }
    
    button {
        margin-top: 20px;
    }
`;

interface IFlashScreenBackgroundStyledProps {
    background: string,
}

export const FlashScreenBackgroundStyled = styled.div<IFlashScreenBackgroundStyledProps>`
    position: absolute;
    width: 282px;
    height: 260px;
    left: 12%;
    top: -10px;
    ${({ background }) => !!background && `background: ${background};`}
    opacity: 0.8;
    filter: blur(83.5px);
    z-index: -1;
`;

export const FlashScreenCloseButtonStyled = styled.div`
    display: flex;
    padding: 8px;
    position: absolute;
    top: 16px;
    right: 16px;
    color: var(--color-label-secondary);
    cursor: pointer;
    border-radius: 16px;
    background-color: var(--color-button-secondary-default);
`;

export const FlashScreenImageWrapperStyled = styled.div`
    img {
        height: 120px;
        width: 120px;
    }
`;
